import React from 'react';

const status_list = {
    'Non traité':'red',
    'Répondeur':'#FFB594',
    'Répondeur 2':'#FFB594',
    'Répondeur 3':'#FFB594',
    'Répondeur 4':'#FFB594',
    'En cours de traitement':'#fbbc03',
    'En attente de retour':'#8a00b2',
    'Traité':'green',
    'Intéressé à recontacter':'#6ded6d',
    'A recontacter':'#0047fd',
    'Intéréssé nous recontacte':'#0092cd',
    'Paiement de l\'accompte validé':'#5ca',
    'Pas intéressé':'#717371',
    'Déjà assuré concurrence':'#4e3d0b',
    'Faux numéro / injoignable':'#22242b',
    'Devis test':'#fff',
    'Doublon':'#fff',
    'Hors cible':'#ED6C30'
}

const status_to_mini = {
    'Répondeur':'1',
    'Répondeur 2':'2',
    'Répondeur 3':'3',
    'Répondeur 4':'4'
}

class StatusDisplay extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        let list = Object.entries(status_list).map( v=>{
            let className = "status_display_item"
            if ( v[1] == '#fff' ) className += " white_item"
            return <div key={v[0]} className={className}>
                <div style={{backgroundColor:v[1]}}></div><span>{v[0]}</span></div>
        })

        return <div className='status_display'>{list}</div>
    }
}

class StatusPicker extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        let container = this.props.container
 
        let list = Object.entries(status_list).map(
            v=>{
                let className = "status_picker_item"
                if ( this.props.status==v[0] ) className += " status_picker_selected"
                return <div key={v[0]} className={className}
                    onClick={ ()=>{ container.pickStatus(v[0]) } }><div style={{backgroundColor:v[1]}} ></div><span>{v[0]}</span></div>
            }
        )

        return <div className='status_picker'>{list}</div>
    }
}

class StatusMarker extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            expanded:false
        }
    }

    pickStatus(status) {
        this.props.container.pickStatus(status)
    }

    onExpand() {
        this.setState({expanded:true})
    }

    render() {
        const content = status_to_mini[this.props.status] || ''
        return <div className='status_marker' style={{backgroundColor:status_list[this.props.status]}} title="Modifier le status"
            onClick={this.props.container.unfoldMarker.bind(this.props.container)}>
            {content}
        </div>
    }
}

export { StatusDisplay, StatusMarker, StatusPicker };

